import { FC} from "react";
import { StatisticsObjectType } from "../caseVolumeLineChart/types";
import CustomComponentDoctors from "../customComponentDoctors";
import CustomComponentEnrollment from "../customComponentEnrollemnt";



const customComponentDoctorsEnrollemnts: FC<StatisticsObjectType> = ({ StatisticsObjectType }): JSX.Element => {

  return (
    <div className="row">
      <div className="col-12 col-md-6">
        <div className="card mt-3">
          <div className="card-header">
            <h4 className="m-0 text-center text-primary">Doctors
            </h4>
          </div>
          <div className="card-body p-0 overflow-y-auto" style={{height:'550px'}}>
              <CustomComponentDoctors StatisticsObjectType={StatisticsObjectType}/>
          </div>
        </div>
      </div>
        <div className="col-12 col-md-6">
          <div className="card mt-3">
            <div className="card-header">
              <h4 className="m-0 text-center text-primary">Enrollments
              </h4>
            </div>
            <div className="card-body p-0 overflow-y-auto" style={{height:'550px'}}>
              <CustomComponentEnrollment StatisticsObjectType={StatisticsObjectType}/>
            </div>
          </div>
        </div>
    </div>
  );
};

export default customComponentDoctorsEnrollemnts;
